import { useSyncExternalStore } from "react";

/**
 * Subscribes to a media query and returns whether it currently matches.
 * SSR-safe (defaults to `false` when `window` is unavailable).
 */
export function useMediaQuery(query) {
  return useSyncExternalStore(
    (onChange) => {
      const mql = window.matchMedia(query);
      mql.addEventListener("change", onChange);
      return () => mql.removeEventListener("change", onChange);
    },
    () => window.matchMedia(query).matches,
    () => false
  );
}
